import { styled } from '@linaria/react';
import { useSpring, animated } from 'react-spring';

import Box from './Box';
import Code from './Code';
import Wrapper from './Wrapper';

function TVTurnOffDemo({ isOn }) {
  const transform = !isOn ? 'scale(0.5, 0)' : 'scale(1, 1)';
  const filter = !isOn ? 'brightness(800%)' : 'brightness(100%)';
  const styles = useSpring({
    transform,
    filter,
    immediate: isOn,
  });

  return (
    <Wrapper>
      <TvBox>
        <Image
          alt="Old-timey black-and-white video, showing people walking in a city"
          src="/images/transforms/old-time.gif"
          style={styles}
        />
      </TvBox>
      <Code>
        transform: {transform};
        <br />
        filter: {filter};
      </Code>
    </Wrapper>
  );
}

const TvBox = styled.div`
  --border: 30px;
  background: hsl(0deg 0% 5%);
  border: var(--border) solid hsl(25deg 30% 20%);
  border-radius: calc(var(--border) + 8px);
  width: calc(306px + calc(var(--border) * 2));
  max-width: 90%;
  aspect-ratio: 306 / 232;
`;

const Image = styled(animated.img)`
  display: block;
  width: 100%;
  border-radius: 8px;
  object-fit: cover;
  will-change: transform;
`;

export default TVTurnOffDemo;
